<template>
    <div v-if="this.showMap()">
        <div class="detail-map">
            <div class="detail-map__panel">
                <div class="detail-map__panel__header">{{ $t('detail.map') }}</div>
                <div class="detail-map__panel__content">
                    <MglMap
                            class="detail-map__panel__content__canvas"
                            :trackResize="true"
                            :attributionControl="false"
                            :accessToken="accessToken"
                            :mapStyle="mapStyle"
                            :center="this.coordinates"
                            :maxZoom="maxZoom"
                            :minZoom="minZoom"
                            :zoom="zoom"
                            @load="mapLoaded">
                        <MglMarker v-if="this.unit.lat && this.unit.lon" :coordinates="[this.unit.lon, this.unit.lat]" color="#b2dd4c65">
                            <MglPopup :closeButton="false">
                                <div class="map-popup">
                                    <h3>{{ $t('map.calculated') }}</h3>
                                    <span>Device ID: {{ this.unit.external.toUpperCase() }}</span>
                                </div>
                            </MglPopup>
                        </MglMarker>
                        <MglMarker v-if="this.unit.manualLat && this.unit.manualLon" :coordinates="[this.unit.manualLon, this.unit.manualLat]" color="#b2dd4c">
                            <MglPopup :closeButton="false">
                                <div class="map-popup">
                                    <h3>{{ $t('map.manual') }}</h3>
                                    <span>Device ID: {{ this.unit.external.toUpperCase() }}</span>
                                </div>
                            </MglPopup>
                        </MglMarker>
                        <MglFullscreenControl position="top-right"></MglFullscreenControl>
                        <MglNavigationControl position="top-right"></MglNavigationControl>
                    </MglMap>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import 'mapbox-gl/dist/mapbox-gl.css';
	import 'vue-mapbox/dist/vue-mapbox.css';
	import Mapbox from "mapbox-gl";
	import {mapGetters} from 'vuex';
	import {dynamicTiming, notifications, dynamicSensing} from '@/config/tentacles.js';
	import {
		MglMap,
		MglMarker,
		MglPopup,
		MglNavigationControl,
		MglFullscreenControl
	} from "vue-mapbox";

	export default {
		name: 'DetailMap',
		props: {
			unit: {
				type: Object,
			}
		},
		components: {
			MglMap,
			MglMarker,
			MglPopup,
			MglNavigationControl,
			MglFullscreenControl
		},
		data() {
			return {
				maxZoom: 20,
				minZoom: 4,
				zoom: 17,
				SOIL_3XS: 1,
				showTimSen: false,
				accessToken: process.env.VUE_APP_MAPBOX_KEY,
				mapStyle: 'mapbox://styles/mapbox/streets-v11' // your map style
			};
		},
		computed: {
			...mapGetters('tentacle', ['type']),
			loading() {
				return this.$store.getters['tentacle/loading'];
			},
			coordinates() {
                if (this.unit.manualLat !== null && this.unit.manualLon !== null){
                	return [this.unit.manualLon, this.unit.manualLat];
                }
				return [this.unit.lon, this.unit.lat];
            }
		},
		created() {
			// We need to set mapbox-gl library here in order to use it in template
			this.mapbox = Mapbox;
		},
		methods: {
			mapLoaded(e) {
				// in component
				this.map = e.map;
			},
			showMap() {
				return (this.unit.lat !== null && this.unit.lon !== null);
			}
		},
	};
</script>
<style>
    canvas.mapboxgl-canvas {
        outline: none;
        border: 0.5px solid rgba(172, 180, 197, 0.31);
        border-top: none;
        border-radius: 0 0 2rem 2rem;
    }
    .mapboxgl-popup-content {
        padding: 5px;
    }

    .map-popup > h3 {
        margin-top: -1px;
        margin-bottom: 2px;
    }
</style>

<style lang="scss" scoped>
    .detail-map {
        padding-left: 8rem;
        @media only screen and (max-width: 990px) {
            padding-left: 0;
            width: 90%;
            margin-right: auto;
            margin-left: 5%;
        }
        @media only screen and (min-width: 991px) and (max-width: 1199px) {
            padding-left: 0;
            width: 90%;
            margin-right: auto;
            margin-left: 5%;
        }
        @media only screen and (min-width: 1200px) and (max-width: 1400px) {
            margin-left: -4%;
            width: 100%;
        }

        &__panel {
            margin-bottom: 4rem;
            border-radius: 2rem;
            background-color: $white;
            box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
            position: relative;
            .loading-wrapper {
                position: absolute;
                top: 5rem;
                width: 100%;
                height: calc(100% - 10rem);
                background-color: rgba(255, 255, 255, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 2;
            }
            &__header {
                padding: 0 3rem;
                height: 6rem;
                border-bottom: 0.1rem solid $border-color;
                display: flex;
                align-items: center;
                font-weight: 600;
                font-size: 1.4rem;
                color: $grey;
            }

            &__content {
                min-height: 42rem;
                @media only screen and (max-width: 1400px) {
                    min-height: 26rem;
                }

                &__canvas {
                    height: 42rem;
                    border-radius: 0 0 2rem 2rem;
                    overflow: hidden;
                }
            }
        }
    }
</style>
